module.exports = __webpack_public_path__ + "img/8bf74ada638944568e06f3e8a40163da-1440.71a9dc26.jpg";